<template>
    <div class="w100 bgWhite" style="min-height: 550px;">
        <article class="wContent center" style="padding-top: 20px">
            <!-- 广告 start -->
            <div v-if="adIDsIndex[0]['list']" style="margin-bottom: 20px;">
                <a v-for="(item, index) in adIDsIndex[0]['list']" :key="index" :href="item.adLink" target="_blank" class="w100 block" style="margin-top: -10px; margin-bottom: -10px;">
                    <img :src="item.adPicturePath" alt="" class="w100">
                </a>
            </div>
            <!-- 广告 end -->

            <ul class="w100 quote-varieties-box" v-show="varietiesList.length > 0">
                <li><a href="javascript:;" class="block fontNormal fontBold font14 textCenter" :class="{'active': varietiesType == ''}" @click="changeVarieties('')">全部</a></li>
                <li v-for="(item, index) in varietiesList" :key="index">
                    <a href="javascript:;" class="block fontNormal fontBold font14 textCenter ellipsis" :class="{'active': varietiesType == item.id}" @click="changeVarieties(item.id)">{{ item.name }}</a>
                </li>
                <!-- <li><a href="javascript:;" class="block fontNormal fontBold font14 textCenter" :class="{'active': varietiesType == 'other'}" style="margin-right: -1px;" @click="changeVarieties('other')">其他</a></!-->
            </ul>
            <div v-show="varietiesList.length > 0">
                <!-- 关键字搜索 start -->
                <div class="textRight w100" style="padding-top: 20px" v-show="!isShowSenior">
                    <div class="quote-key-input inlineBlock">
                        <el-input placeholder="请输入内容" v-model="searchKey">
                            <template slot="append">
                                <a href="javascript:;" class="fontWhite" @click="findOfferVarieties('simple')">搜索</a>
                            </template>
                        </el-input>
                    </div>
                    <div class="inlineBlock quote-senior-btn" v-show="varietiesType != ''">
                        <el-button @click="isShowSenior = true; seniorForm.varietiesId = ''">高级搜索</el-button>
                    </div>
                    <el-button type="primary" class="bgRed" style="border: 0;" @click="goAddQuote">我要发布报价</el-button>
                </div>
                <!-- 关键字搜索 end -->

                <!-- 高级搜索 start -->
                <div class="w100 quote-senior-box" style="padding: 20px 5px 10px 5px;" v-show="isShowSenior">
                    <el-row>
                        <el-col :span="21">
                            <div class="grid-content">
                                <el-form :inline="true" :model="seniorForm" class="" label-width="120px">
                                    <el-form-item label="品种">
                                        <el-select v-model="seniorForm.varietiesId" placeholder="请选择" @change="changeSeniorVari">
                                            <el-option v-for="item in varietiesChildList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item v-for="(item, index) in varietiesChild" :label="item.content" :key="index">
                                        <el-select v-model="seniorForm['attributeId'][index]" placeholder="请选择" @change="changeVarietiesChild(item, index)">
                                            <el-option v-for="cItem in item.fieldInfos" :key="cItem.id" :label="cItem.fieldValue" :value="cItem.id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="市场">
                                        <!-- <el-input v-model="seniorForm.marketKeys" placeholder="市场"></el-input> -->
                                        <el-cascader :props="props" v-model="marketKeys" separator="-"></el-cascader>
                                    </el-form-item>
                                    <el-form-item label="关键字">
                                        <el-input v-model="seniorForm.searchKey" placeholder="请输入关键字"></el-input>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </el-col>
                        <el-col :span="3">
                            <div class="quote-btn-content textRight">
                                <el-button size="mini" style="margin-top: 10px;" @click="isShowSenior = false">收起</el-button><br>
                                <div class="quote-form-btns">
                                    <el-button size="small" type="danger" @click="findOfferVarieties">搜索</el-button>
                                    <el-button size="small" type="info" @click="handleDefault">重置</el-button>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <div class="textRight" style="margin-top: 20px;" v-show="isShowSenior">
                    <el-button type="primary" class="bgRed" style="border: 0;" @click="goAddQuote">我要发布报价</el-button>
                </div>
                <!-- 高级搜索 end -->
            </div>

            <!-- 列表 start -->
            <div v-show="!none">

                <div class="quote-list-box" v-for="(item, index) in tableList" :key="index">
                    <span class="recommend-status" v-show="item.recommendStatus"></span>
                    <el-row :gutter="10">
                        <el-col :span="5">
                            <div class="font14 fontRed list">
                                <span class="block quote-enterprise-name">
                                    <img src="../../assets/images/quote_gongsi.png" alt="">
                                    <span class="ellipsis inlineBlock vMid">{{ item.enterpriseName }}</span>
                                    <small class="inlineBlock vMid textCenter fontRed" style="margin-top: 2px;" v-show="item.benchmarkStatus">基</small>
                                </span>
                                <span class="block quote-enterprise-name">
                                    <img src="../../assets/images/quote_lianxifangshi.png" alt="" style="width: 16px; height: 16px; margin-top: -1px;">
                                    <span class="ellipsis inlineBlock vMid">{{ item.enterprisePhone }}</span>
                                </span>
                            </div>
                        </el-col>
                        <el-col :span="9">
                            <div class="list">
                                <span class="block font16 fontBold ellipsis">
                                    <span>{{ item.varietiesName || '' }}</span>  
                                    
                                    <el-tooltip class="item" effect="dark" :content="item.attribute" placement="bottom" v-show="item.attribute">
                                        <span class="font14" style="padding-left: 15px;">{{ item.attribute || '' }}</span> 
                                    </el-tooltip>
                                </span>
                                <span class="block font16 ellipsis">
                                    <span class="fontRed fontBold">{{ item.price }}</span> 
                                    <span class="font14" style="margin-left: 15px;">{{ item.factory }} &nbsp;&nbsp; {{ item.warehouse }}</span>
                                </span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="list">
                                <span class="block font14 fontLight ellipsis">
                                    {{ item.market }}
                                </span>
                                <span class="block font14 fontLight ellipsis">
                                    <el-tooltip class="item" effect="dark" :content="item.remark" placement="bottom" v-show="item.remark">
                                        <span class="font14">{{ item.remark }}</span> 
                                    </el-tooltip>
                                    
                                </span>
                            </div>
                        </el-col>
                        <el-col :span="2">
                            <div class="textCenter list">
                                <span class="block font14 fontLight">{{ item.offerDate || '&nbsp;'}}</span>
                                <span class="font14 fontRed block pointer fontBold" @click="goQuoteDetail(item.userPhone)">查看更多</span>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <!-- 列表 end -->

                <!-- 分页 start -->
                <div class="textCenter" style="padding-top: 20px; padding-bottom: 20px;" v-show="true">
                    <el-pagination background @current-change="handleCurrentChange" :current-page="pageNo" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalnum"></el-pagination>
                </div>
                <!-- 分页 end -->
            </div>

            <div class="textCenter font16 fontNormal" style="padding-top: 20px;" v-show="none">暂无报价信息~</div>

        </article>
        <Login ref="loginDialog"></Login>
    </div>
</template>
<script>
import $ from 'jquery'
import Login from '../../templates/loginControl'
import { baseUrl, adIDs, getQueryString } from '../../assets/js/common'
export default {
    name: 'Quote',
    components: { Login },
    data() {
        const self = this;
        return {
            adIDsIndex: [{
                name: 'qybj',
                id: adIDs['qybj'],
                list: []
            }],
            varietiesType: '',
            varietiesList: [],
            varietiesChildList: [],
            varietiesChild: {},
            props: {
                lazy: true,
                value: 'areaName',
                label: 'areaName',
                checkStrictlt: true,
                lazyLoad (node, resolve) {
                    if (node.level == 0) {
                        self.findAreaByLevel(resolve);
                    } else if (node.level == 1) {
                        self.findAreaByPid(node.data.areaCode, resolve);
                    } else {
                        // console.log(node)
                        resolve(undefined)
                        if (node.level == 2) {
                            self.marketKeys = [];
                            self.marketKeys.push(node.parent.value);
                            self.marketKeys.push(node.value);
                        }
                    }
                }
            },
            marketKeys: [],
            searchKey: '',
            tableList: [],
            none: false,
            isShowSenior: false,
            seniorForm: {
                varietiesId: '',
                attributeId: [],
                attributeIds: [], // 修改后的属性参数
                marketKeys: '',
                searchKey: '',
                status: true,
                beginDate: '',
                endDate: ''
            },
            pageNo: 1,
            pageSize: 12,
            totalnum: 0
        }
    },
    mounted () {
        this.varietiesType = getQueryString('type') ? getQueryString('type') : '';
        this.findAllVarieties();
        this.getAdByAdp();
    },
    methods: {
        // 获取广告信息
        getAdByAdp () {
            const self = this;
            self.adIDsIndex.forEach((item, index) => {
                self.$get(`${baseUrl.cyw}/industriaAD/getAdByAdp?adpId=${item.id}`, {}).then(res => {
                    if (res.code == 0) {
                        self.adIDsIndex[index]['list'] = res.data;
                    }
                })
            })
        },
        // 切换产品
        changeVarieties (type) {
            this.varietiesType = type;
            if (type) {
                this.varietiesChild = []
                this.findVarietiesById();
            } 
            this.isShowSenior = false;
            this.marketKeys = [];
            this.searchKey = '';
            this.seniorForm = {
                varietiesId: '',
                attributeId: [],
                attributeIds: [],
                marketKeys: '',
                searchKey: '',
                status: 'true',
                beginDate: '',
                endDate: ''
            }
            this.findOfferVarieties(type);
        },

        // 获取全部产品
        findAllVarieties () {
            const self = this;
            self.$get(`${baseUrl.business}/api/varieties/findAll`, {}).then(res => {
                if (res.status == 200) {
                    self.varietiesList = res.data;
                    self.findOfferVarieties();
                } else {
                    self.$message.error(res.msg);
                }
            })
        },
        // 获取一级产品分类下的所有产品
        findVarietiesById () {
            const self = this;
            self.$get(`${baseUrl.business}/api/varieties/find/${self.varietiesType}`, {}).then(res => {
                if (res.status == 200) {
                    self.varietiesChildList = res.data.varietiesSet;
                } else {
                    self.$message.error(res.msg);
                }
            })
        },
        // 根据选择的产品展示属性
        changeSeniorVari (val) {
            const child = this.varietiesChildList.filter((datas) => {
                return datas.id == val;
            })
            this.varietiesChild = child[0].attributeInfos;
        },
        // 切换属性
        changeVarietiesChild (item, index) {
            const self = this;
            let obj = {};
            item.fieldInfos.forEach((cItem, cIndex) => {
                if (self.seniorForm.attributeId[index] == cItem.id) {
                    obj = {
                        attributeInfoId: item.id, // 属性id
                        fieldInfoId: cItem.id // 属性值id
                    }
                    self.seniorForm.attributeIds[index] = obj;
                }
            })
        },
        // 获取所有省数据、
        findAreaByLevel (callback) {
            const self = this;
            self.$get(`${baseUrl.business2}/ts-dictionaries/dictarea/findAreaByLevel/2`, {}).then(res => {
                if (res.code == '0') {
                    callback(res.data)
                }
            })
        },
        // 获取所有市数据
        findAreaByPid (code, callback) {
            const self = this;
            self.$get(`${baseUrl.business2}/ts-dictionaries/dictarea/findAreaByPid/${code}`, {}).then(res => {
                if (res.code == '0') {
                    callback(res.data)
                }
            })
        },
        // 重置
        handleDefault () {
            this.seniorForm = {
                varietiesId: '',
                attributeId: [],
                attributeIds: [],
                marketKeys: '',
                searchKey: '',
                status: 'true',
                beginDate: '',
                endDate: ''
            }
            this.marketKeys = '';
            this.varietiesChild = [];
        },
        // 查询报价列表
        findOfferVarieties (type) {
            const self = this;
            self.tableList = [];
            const params = $.extend(true, {}, self.seniorForm);
            if (type == 'simple') {
                params.searchKey = self.searchKey.replace(/\s*/g,"");
            } else {
                params.searchKey = params.searchKey.replace(/\s*/g,"");
            }
            if (self.marketKeys.length > 0) {
                const val = self.marketKeys[0] + '-' + self.marketKeys[1];
                params.marketKeys = val;
            }
            params.attributeIds = params.attributeIds.filter(function (s) {
                return s;
            });
            if (!params.varietiesId) {
                params.varietiesId = self.varietiesType;
            }
            delete params.attributeId;

            self.$post(`${baseUrl.business}/api/offer/showAll/${self.pageNo - 1}/${self.pageSize}`, params).then(res => {
                if (res.status == 200) {
                    if (res.data.content.length > 0) {
                        const content = res.data.content;
                        let obj = {};
                        content.forEach((item, index) => {
                            obj = {
                                enterpriseName: item.enterpriseVarieties.enterpriseInfo.name,
                                enterprisePhone: item.enterpriseVarieties.enterpriseInfo.phone,
                                userPhone: item.enterpriseVarieties.user.userPhone,
                                benchmarkStatus: item.enterpriseVarieties.enterpriseInfo.benchmarkStatus,
                                recommendStatus: item.enterpriseVarieties.enterpriseInfo.recommendStatus,  //推荐状态
                                market: item.enterpriseVarieties.market,
                                factory: item.enterpriseVarieties.factory,
                                warehouse: item.enterpriseVarieties.warehouse,
                                remark: item.remark,
                                price: item.price,
                                offerDate: item.offerDate,
                                varietiesName: item.enterpriseVarieties.varieties.name,
                                attribute: ''
                            }
                            const attributeInfoFiledInfos = item.enterpriseVarieties.attributeInfoFiledInfos ? item.enterpriseVarieties.attributeInfoFiledInfos : [];
                            let attribute_arr = [];
                            attributeInfoFiledInfos.forEach((cItem, cIndex) => {
                                attribute_arr.push(cItem.fieldInfo ? cItem.fieldInfo.fieldValue : '')
                            })
                            obj.attribute = attribute_arr.join(', ');
                            self.tableList.push(obj);
                        })
                        self.none = false;
                        self.totalnum = res.data.totalElements;
                    } else {
                        self.none = true;
                    }
                }
            })
        },

        // 切换分页
        handleCurrentChange (page) {
            this.pageNo = page;
            this.findOfferVarieties();
        },

        // 跳转到发布页
        goAddQuote (id) {
            if (this.$cookies.get('token_cyw')) {
                this.$router.push(`/home/selfPage?type=发布报价`);
            } else {
                this.$refs.loginDialog.init();
            }
        },
        // 跳转到企业详情页
        goQuoteDetail (phone) {
            let routeUrl = this.$router.resolve({
                path: `/home/quoteDetail?id=${phone}`
            });
            window.open(routeUrl .href, '_blank');
            // this.$router.push(`/home/quoteDetail?id=${phone}`);
        }
    }
    
}
</script>

<style scoped>
    .fontRedLight { color: #F56C6C; }
    .quote-varieties-box { display: flex; border: 1px solid #e0e0e0; padding: 0; margin: 0; box-sizing: border-box; }
    .quote-varieties-box > li { flex: 1; width: 100% }
    .quote-varieties-box > li > a { line-height: 40px; background: #DCDFE6; box-sizing: border-box; }
    .quote-varieties-box > li > a.active { background: #fff; color: #a30000 !important; border-right: 1px solid #c0c4cc; }
    .quote-key-input { width: 300px; margin-right: 20px; }
    .quote-senior-btn { margin: 0 20px 0 0px; }
    .quote-senior-btn .el-button--default,
    .quote-senior-btn .el-button--default:hover,
    .quote-btn-content .el-button--mini,
    .quote-btn-content .el-button--mini:hover { border-color: #a30000; color: #a30000; background: #fff; }
    .quote-btn-content .el-button--danger,
    .quote-btn-content .el-button--danger:hover { background: #a30000; border-color: #a30000 }
    .quote-form-btns .el-button--info:hover { background: #909399; border-color: #909399; }
    .quote-form-btns { margin-top: 30px; }
    .quote-senior-box { border: 1px solid #c0c4cc; box-sizing: border-box; margin-right: -2px; }
    .quote-list-box { margin-top: 15px; padding: 10px 10px 10px 35px; border: 1px solid #ccc; border-radius: 2px; position: relative; }
    /* .quote-list-box > ul:first-child { margin-bottom: 8px; }
    .quote-list-box > ul { margin-bottom: 2px; line-height: 22px; }
    .quote-list-box > ul > li > .quote-enterprise-name > span {
        vertical-align: middle;
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap; 
    } */
    .quote-list-box .list { line-height: 30px; }
    .quote-enterprise-name > span { width: 80%; }
    .quote-list-box .quote-enterprise-name small { line-height: 18px; width: 18px; height: 18px; border: 1px solid #a30000; border-radius: 1px; font-size: 12px; margin-top: -2px; margin-left: 5px; }
    .quote-list-box .quote-enterprise-name img { width: 16px; height: 16px; vertical-align: middle; margin-top: -3px; margin-right: 2px; }
    .quote-list-box .recommend-status { position: absolute; top: 0; left: 0; width: 40px; height: 40px; background: url('../../assets/images/trade_tuijian.png') no-repeat; background-size: 100% 100%; }
</style>


